<p>© {{this.todayDate.getFullYear()}} Atlas Copco Group | Hybrid Integration Platform | All Rights Reserved</p>
